/** 员工关系 **/
import Layout from "@/views/layout/Layout";
// component: () => import("@/views/hrMan/orgPlan/index"),
const staffRelationRouter = {
  path: "/staffRelation",
  component: Layout,
  redirect: "/examMan/course/list",
  name: "staffRelation",
  meta: {
    title: "员工关系",
    icon: "staffRelation",
    roles: ["yg_yuangongguanxi"],
  },

  children: [
    {
      path: "employerInsuranceMan",
      component: () => import("@/views/hrMan/orgPlan/index"),
      name: "employerInsuranceMan",
      meta: {
        title: "雇主险管理",
        roles: ["yg_guzhuxianguanli"],
      },
      children: [
        {
          path: "dayTableMan",
          component: () =>
            import(
              "@/views/staffRelation/employerInsuranceMan/dayTableMan/index"
            ),
          name: "dayTableMan",
          meta: {
            title: "日明细表管理",
            roles: ["yg_rimingxibiaoguanli"],
          },
          children: [],
        },
        {
          path: "monthTableMan",
          component: () =>
            import(
              "@/views/staffRelation/employerInsuranceMan/monthTableMan/index"
            ),
          name: "monthTableMan",
          meta: {
            title: "月报表管理",
            roles: ["yg_yuebaobiaoguanli"],
          },
          children: [],
        },

        {
          path: "yearTableMan",
          component: () =>
            import(
              "@/views/staffRelation/employerInsuranceMan/yearTableMan/index"
            ),
          name: "yearTableMan",
          meta: {
            title: "年度报表",
            roles: ["yg_niandubaobiao"],
          },
          children: [],
        },
      ],
    },

    {
      path: "workInjuryMan",
      component: () => import("@/views/hrMan/orgPlan/index"),
      name: "workInjuryMan",
      meta: {
        title: "工伤管理",
        roles: ["yg_gongshangguanli"],
      },
      children: [
        {
          path: "accidentHandling",
          component: () =>
            import("@/views/staffRelation/workInjuryMan/accidentHandling"),
          name: "accidentHandling",
          meta: {
            title: "事故处理",
            roles: ["yg_shiguchuli"],
          },
          children: [],
        },
        {
          path: "accidentDataStatistics",
          component: () => import("@/views/hrMan/orgPlan/index"),
          name: "accidentDataStatistics",
          meta: {
            title: "事故数据统计",
            roles: ["yg_shigushujutongji"],
          },
          children: [
            {
              path: "statisticsSheet",
              component: () =>
                import(
                  "@/views/staffRelation/accidentDataStatistics/statisticsSheet/index"
                ),
              name: "statisticsSheet",
              meta: {
                title: "事业部工伤统计单",
                roles: ["yg_shiyebugongshangtongjidan"],
              },
              children: [],
            },
            {
              path: "statisticalTable",
              component: () =>
                import(
                  "@/views/staffRelation/accidentDataStatistics/statisticalTable/index"
                ),
              name: "statisticalTable",
              meta: {
                title: "工伤统计单",
                roles: ["yg_gongshangtongjidan"],
              },
              children: [],
            },
          ],
        },
      ],
    },

    {
      path: "socialSecurityMan",
      component: () => import("@/views/hrMan/orgPlan/index"),
      name: "socialSecurityMan",
      meta: {
        title: "社保管理",
        roles: ["yg_shebaoguanli"],
      },
      children: [
        {
          path: "monthlyDetails",
          component: () =>
            import(
              "@/views/staffRelation/socialSecurityMan/monthlyDetails/index"
            ),
          name: "monthlyDetails",
          meta: {
            title: "月度社保明细",
            roles: ["yg_yuedushebaomingxi"],
          },
          children: [],
        },
        {
          path: "socialMain",
          component: () =>
            import("@/views/staffRelation/socialSecurityMan/socialMain/index"),
          name: "socialMain",
          meta: {
            title: "社保定员维护",
            roles: ["yg_shebaodingyuanweihu"],
          },
          children: [],
        },
        {
          path: "reportMan",
          component: () => import("@/views/hrMan/orgPlan/index"),
          name: "reportMan",
          meta: {
            title: "报表管理",
            roles: ["yg_baobiaoguanli"],
          },
          children: [
            {
              path: "detailsTable",
              component: () =>
                import(
                  "@/views/staffRelation/socialSecurityMan/reportMan/detailsTable/index"
                ),
              name: "detailsTable",
              meta: {
                title: "月度社保明细表",
                roles: ["yg_yuedushebaomingxibiao"],
              },
              children: [],
            },
            {
              path: "analysisTable",
              component: () =>
                import(
                  "@/views/staffRelation/socialSecurityMan/reportMan/analysisTable/index"
                ),
              name: "analysisTable",
              meta: {
                title: "月度社保分析表",
                roles: ["yg_yuedushebaofenxibiao"],
              },
              children: [],
            },
            {
              path: "deductionTable",
              component: () =>
                import(
                  "@/views/staffRelation/socialSecurityMan/reportMan/deductionTable/index"
                ),
              name: "deductionTable",
              meta: {
                title: "月度社保扣款表",
                roles: ["yg_yuedushebaokoukuanbiao"],
              },
              children: [],
            },
            {
              path: "informationTable",
              component: () => import("@/views/hrMan/orgPlan/index"),
              name: "informationTable",
              meta: {
                title: "个税基础信息表",
                roles: ["yg_geshuijichuxinxibiao"],
              },
              children: [
                {
                  path: "normalTable",
                  component: () =>
                    import(
                      "@/views/staffRelation/socialSecurityMan/reportMan/informationTable/normalTable/index"
                    ),
                  name: "normalTable",
                  meta: {
                    title: "正常薪金所得表",
                    roles: ["yg_zhengchangxinzisuodebiao"],
                  },
                  children: [],
                },
                {
                  path: "infoTable",
                  component: () =>
                    import(
                      "@/views/staffRelation/socialSecurityMan/reportMan/informationTable/infoTable/index"
                    ),
                  name: "infoTable",
                  meta: {
                    title: "人员信息表",
                    roles: ["yg_renyuanxinxibiao"],
                  },
                  children: [],
                },
              ],
            },
          ],
        },
      ],
    },
    // == 临时雇主险管理
    {
      path: "temporaryEmployerInsuranceMan",
      component: () => import("@/views/hrMan/orgPlan/index"),
      name: "temporaryEmployerInsuranceMan",
      meta: {
        title: "临时雇主险管理",
        roles: ["yg_linshiguzhuxian"],
      },
      children: [
        {
          path: "myInsurance",
          component: () =>
            import(
              "@/views/staffRelation/temporaryEmployerInsuranceMan/myInsurance/index"
            ),
          name: "myInsurance",
          meta: {
            title: "我的临时雇主保险单",
            roles: ["yg_wodelinshiguzhudan"],
          },
          children: [],
        },
        {
          path: "insuranceMan",
          component: () =>
            import(
              "@/views/staffRelation/temporaryEmployerInsuranceMan/insuranceMan/index"
            ),
          name: "insuranceMan",
          meta: {
            title: "临时雇主保险单管理",
            roles: ["yg_linshiguzhudanguanli"],
          },
          children: [],
        },
      ],
    },

    // == 4季度新需求
    {
      path: "staffArchive",
      component: () => import("@/views/staffRelation/staffArchive"),
      name: "staffArchive",
      meta: {
        title: "员工档案",
        roles: ["danganguanliyunying"],
        keepAlive: true
      }
    },
    {
      path: "handoverHistory",
      component: () => import("@/views/staffRelation/handoverHistory"),
      name: "handoverHistory",
      meta: {
        title: "交接记录",
        roles: ["danganguanliyunying"],
        keepAlive: true
      }
    },
    
  ],
};

export default staffRelationRouter;
